<template>
  <div>
    <div class="-m-3 flow-root">
      <!-- START HEADER -->

      <div id="hero" class="mt-4">
        <div class="relative overflow-hidden bg-white text-white">
          <div class="relative h-[180px] overflow-hidden">
            <img
              src="/img/biologisch.png"
              class="absolute inset-0 size-full object-cover"
              alt=""
            />
            <div class="relative">
              <div
                class="pt-10 pb-2 text-center text-5xl font-bold text-menuheadertext"
              >
                Menü der Woche
              </div>
              <div
                v-if="isSignedIn"
                class="flex justify-center px-8 pt-1 text-4xl font-normal text-menuheadertext"
              >
                <div class="-m-3 flex flex-auto flex-wrap">
                  <div class="w-3/12 shrink-0 p-3">
                    <LoginComponent />
                  </div>
                  <div class="w-3/12 shrink-0 p-3">
                    <UFormField label="Date input" class="max-w-[300px]">
                      <UInputDate v-model="newDate" class="w-full" />
                    </UFormField>
                  </div>
                </div>
              </div>

              <div
                v-else
                class="px-8 pt-1 text-center text-4xl font-normal text-menuheadertext"
              >
                {{ formattedDate(monday) }} -
                {{ formattedDate(friday) }}
              </div>

              <div
                class="pt-3 text-center text-xs tracking-[0.0333em] text-menuheadertext"
              >
                Vorbehaltlich kurzfristiger Änderungen durch den Caterer.
                Informationen zu Zusatzstoffen und Allergenen siehe Aushang.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- END HEADER -->

      <div class="p-8 pl-10">
        <div class="-m-3 flex flex-wrap">
          <!-- START DESCRIPTION -->

          <div class="menucol max-w-[160px] min-w-0 flex-1">
            <div
              class="menu-card active relative overflow-hidden bg-white wrap-break-word"
            >
              <div
                class="menu-card-text calendar-bg p-4 text-sm tracking-[0.0179em]"
              >
                <div
                  class="menu-card relative mt-2 mb-6 overflow-hidden bg-white p-3 wrap-break-word"
                >
                  <div class="menu-card-text p-4 text-sm tracking-[0.0179em]">
                    <div class="menu-row -m-3 flex flex-wrap">
                      <div class="turkis text-center text-xl">Rohkost</div>
                    </div>
                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="turkis text-center text-xl">
                        Menü <br /><span class="text-6xl font-light">1</span>
                      </div>
                    </div>
                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="turkis text-center text-xl">
                        Menü <br /><span class="text-6xl font-light">2</span>
                      </div>
                    </div>
                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="turkis text-center text-xl">
                        Menü <br /><span class="text-6xl font-light">3</span>
                      </div>
                    </div>
                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="turkis text-center text-xl">
                        Dessert <br /><span class="text-6xl font-light" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- END DESCRIPTION -->

          <!-- START MENUE -->
          <div
            v-for="(item, index) in sortedAndPaddedWeeklyMenu"
            :key="index"
            class="menucol min-w-0 flex-1"
          >
            <div
              class="menu-card relative overflow-hidden bg-white wrap-break-word"
              :class="{
                active: formattedDate(item.date) == formattedDate(today),
              }"
            >
              <div class="menu-card-text p-4 text-sm tracking-[0.0179em]">
                <div
                  class="menu-card calendar-bg relative mt-2 mb-6 overflow-hidden bg-white p-3 wrap-break-word"
                >
                  <div class="card-date px-2 pb-2">
                    <div class="flex">
                      <div>
                        <div class="text-center text-4xl font-bold">
                          {{ formattedDateWeekday(item.date) }}
                          <span class="text-xl">{{
                            formattedDateShort(item.date)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="item.isclosed"
                    class="menu-card-text p-4 text-sm tracking-[0.0179em]"
                  >
                    <div class="menu-row -m-3 flex flex-wrap" />

                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">-- heute geschlossen --</div>
                      </div>
                    </div>

                    <div class="menu-row -m-3 mt-3 flex flex-wrap" />
                    <div class="menu-row -m-3 mt-3 flex flex-wrap" />
                  </div>

                  <div
                    v-if="!item.isclosed"
                    class="menu-card-text p-4 text-sm tracking-[0.0179em]"
                  >
                    <div class="menu-row -m-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">
                          {{ item.rawFood?.substring(0, 47) }}
                        </div>
                      </div>
                    </div>

                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">
                          <MenuDietBadges :tags="item.isMenu1" />
                          {{ item.menu1?.substring(0, 143) }}
                        </div>
                      </div>
                    </div>

                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">
                          <MenuDietBadges :tags="item.isMenu2" />
                          {{ item.menu2?.substring(0, 143) }}
                        </div>
                      </div>
                    </div>

                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">
                          <MenuDietBadges :tags="item.isMenu3" />
                          {{ item.menu3?.substring(0, 143) }}
                        </div>
                      </div>
                    </div>

                    <div class="menu-row -m-3 mt-3 flex flex-wrap">
                      <div class="min-w-0 flex-1 p-0">
                        <div class="pb-3 text-xl">
                          <MenuDietBadges :tags="item.isDessert" />
                          {{ item.dessert?.substring(0, 47) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- END MENUE -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import 'assets/scss/menu.scss';
import { getLocalTimeZone, type CalendarDate } from '@internationalized/date';

const auth = useAuth();

const props = defineProps({
  items: { required: true, type: Object as PropType<Array<IMenuItem>> },
});

const isSignedIn = computed(() => auth.status.value === 'authenticated');

enum DayEnum {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
}

function getDayOfTheWeek(date: Date, offset: DayEnum = DayEnum.MONDAY) {
  date = new Date(date);
  const day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1) + offset; // adjust when day is sunday
  const ret = new Date(date.setDate(diff));
  return ret;
}

// const today = new Date('06 august 2024 00:01');
const newDate = shallowRef<CalendarDate>();
watch(newDate, (newValue) => {
  if (!newValue) return;
  today.value = newValue.toDate(getLocalTimeZone());
});

const today = ref<Date>(new Date());

const monday = computed(() => {
  if (today.value.getDay() === 6 || today.value.getDay() === 0) {
    // Show next week on sat. and sun.
    const spacerdate = getDayOfTheWeek(today.value, DayEnum.MONDAY);
    spacerdate.setDate(spacerdate.getDate() + 7);
    return spacerdate;
  } else return getDayOfTheWeek(today.value, DayEnum.MONDAY);
});

const friday = computed(() => {
  if (today.value.getDay() === 6 || today.value.getDay() === 0) {
    // Show next week on sat. and sun.
    const spacerdate = getDayOfTheWeek(today.value, DayEnum.FRIDAY);
    spacerdate.setDate(spacerdate.getDate() + 7);
    return spacerdate;
  } else return getDayOfTheWeek(today.value, DayEnum.FRIDAY);
});

const sortedWeeklyMenu = computed(() => {
  if (typeof props.items === 'undefined') return [];
  if (typeof props.items === 'undefined') return [];

  const items = props.items;
  const mondayDateString = convertDate(monday.value);
  const fridayDateString = convertDate(friday.value);
  const itemsWithDate = items.map((item) => ({
    ...item,
    localeDate: convertDate(new Date(item.date)),
  }));

  return itemsWithDate
    .filter((item) => mondayDateString <= item.localeDate)
    .filter((item) => fridayDateString >= item.localeDate)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
});

function convertDate(d: Date) {
  return rearrangeDateString(
    d.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  );
}

function rearrangeDateString(s: string) {
  const a = s.split('.');
  return `${a[2]}-${a[1]}-${a[0]}`;
}

function formattedDate(date: Date | string) {
  const formatDate = new Date(date);
  return `${formatDate.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}`;
}

function formattedDateShort(date: Date | string) {
  const formatDate = new Date(date);
  return `${formatDate.toLocaleDateString('de-DE', { month: '2-digit', day: '2-digit' })}`;
}

function formattedDateWeekday(date: Date | string) {
  const formatDate = new Date(date);
  return `${formatDate.toLocaleDateString('de-DE', { weekday: 'short' })}`;
}

const sortedAndPaddedWeeklyMenu = computed(() => {
  const items = [];
  for (let i = 1; i < 6; i++) {
    const day = (i - 1) as DayEnum;
    const item = sortedWeeklyMenu.value.find(
      (item) => new Date(item.date).getDay() === i
    );
    items.push(
      item
        ? { ...item, day }
        : {
            date: getDayOfTheWeek(today.value, day),
            isclosed: false,
            rawFood: ' ',
            menu1: ' ',
            isMenu1: [],
            menu2: ' ',
            isMenu2: [],
            menu3: ' ',
            isMenu3: [],
            dessert: ' ',
            isDessert: [],
            day,
          }
    );
  }
  return items;
});

onNuxtReady(() => {
  setInterval(() => (today.value = new Date()), 86400000);
});
</script>
